import type { QueryClient } from "@tanstack/react-query";

/** Integrations and product-create selling share these caches. */
export function connectorQueryKeys(orgId: string) {
  return {
    list: ["connectors", orgId] as const,
    createRefs: ["create-product-refs", orgId] as const,
  };
}

export function invalidateConnectorQueries(queryClient: QueryClient, orgId: string | null | undefined) {
  if (!orgId) return;
  const keys = connectorQueryKeys(orgId);
  void queryClient.invalidateQueries({ queryKey: keys.list });
  void queryClient.invalidateQueries({ queryKey: keys.createRefs });
}
